import Immutable from 'immutable';

const LOAD = 'practice/LOAD';
const LOAD_SUCCESS = 'practice/LOAD_SUCCESS';
const LOAD_FAIL = 'practice/LOAD_FAIL';
const LOAD_SUCCESS_DOCTOR = 'practice/LOAD_SUCCESS_DOCTOR';
const LOAD_FAIL_DOCTOR = 'practice/LOAD_FAIL_DOCTOR';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  practicesOption: [],
  doctorPracticesOption: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('practicesOption', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('practicesOption', null);

    case LOAD_SUCCESS_DOCTOR:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('doctorPracticesOption', action.res);

    case LOAD_FAIL_DOCTOR:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('doctorPracticesOption', null);

    default:
      return state;
  }
};

export const getPractices = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`practices`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getPracticesInfo = (params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`practices/practiceInfo${params}`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getDoctorPractices = (doctorId, params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`practices/doctor/${doctorId}/${params}`);
    dispatch({ type: LOAD_SUCCESS_DOCTOR, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL_DOCTOR, error: err.message });
  }
};
